import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { SignUpNewsletterModalButton } from '../SignUpNewsletterModalButton/SignUpNewsletterModalButton';
import { CallToActionBanner, CallToActionBannerProps } from '@bepure/tarkin';

class CallToAction extends React.PureComponent<CallToActionBannerProps> {
    public render() {
        return (
            <CallToActionBanner
                message={this.props.message}
                button={this.props.button}
                children={this.props.children}
                styles={this.props.styles}
                backgroundImage={this.props.backgroundImage}
            />
        );
    }
}

const goTo = (url: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
    window.location.href = url;
};

export default function render() {
    const elements = document.getElementsByClassName('call-to-action-banner');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const text = element.dataset.message || '';
        const buttonText = element.dataset.buttondescription || 'Sign Up';
        const backgroundImage = element.dataset.backgroundimage || undefined;
        const buttonLink = element.dataset.buttonlink || undefined;
        const type = element.dataset.type || 'sign_up_to_newsletter';

        let ctaButton;
        const buttonClasses = 'btn btn--secondary margin--auto disable-on-modal-open';
        if (type === 'sign_up_to_newsletter') {
            ctaButton = (
                <SignUpNewsletterModalButton
                    buttonClasses={buttonClasses}
                    buttonText={buttonText}
                />
            );
        } else {
            ctaButton = (
                <button id={'call_to_action_banner'} className={`${buttonClasses || ''}`} onClick={buttonLink ? goTo(buttonLink) : undefined}>{buttonText}</button>
            );
        }

        return ReactDOM.render(
            <CallToAction message={text} children={ctaButton} backgroundImage={backgroundImage} />,
            element,
        );
    });
}
